@if (!!offer) {
  <bp-modal-header [title]="title">
    <a right class="hover-pointer" (click)="close()" (keydown.enter)="close()" [tabIndex]="0" data-dismiss="modal">
      {{ "cancel" | translate }}
    </a>
  </bp-modal-header>
  <div class="bp-modal-body">
    <div
			[ngClass]="{
				'bp-modal-body-section mod-wide pt-25 pb-0': createdFwt
			}">
      <div class="bp-modal-body-section mod-wide pt-25 pb-0" [ngClass]="{ 'mod-transparent': createdFwt }">
        <div class="bp-modal-description">{{ "summary_sub_header" | translate }}</div>
        <div class="summary-grid">
          <summary-grid
            step="1"
            titleKey="summary_container_one_deposit"
            class="summary-grid-item"
            [cssHover]="!createdFwt"
            [cssGrayOut]="createdFwt"
            (onStepClick)="setEdit($event)">
            <ng-container iconContainer>
              <div class="summary-card__currency-symbol mb-10">
                <img
                  [src]="fiat.getLogo() ?? '/assets/images/default-asset.svg'"
                  [style.width.px]="42"
                  (error)="img.src = fiat.getDefaultLogo()"
                  alt="{{ 'logo_alt_text' | translate }}"
                  #img />
              </div>
            </ng-container>
            <ng-container detailsContainer>
              <span class="summary-card__text">{{ fiat.getName() }} {{ "wallet" | translate }}</span>
            </ng-container>
          </summary-grid>
          <summary-grid
            step="2"
            titleKey="summary_container_two_deposit"
            class="summary-grid-item"
            [cssHover]="!createdFwt"
            [cssGrayOut]="createdFwt"
            (onStepClick)="setEdit($event)">
            <ng-container iconContainer>
              <img
                class="summary-card__image mb-10"
                [src]="provider?.getLogo()"
                [style.min-width]="'auto'"
                alt="{{ provider?.getName() }}" />
            </ng-container>
            <ng-container detailsContainer>
              <span class="summary-card__text">{{ provider?.getName() }}</span>
            </ng-container>
          </summary-grid>
          <summary-grid
            step="3"
            titleKey="amount_summary_deposit"
            class="summary-grid-item"
            [cssHover]="!createdFwt"
            [cssGrayOut]="createdFwt"
            (onStepClick)="setEdit($event)">
            <ng-container detailsContainer>
              <div class="text-big-black mb-10">
                <strong>
                  {{
                  getOfferAmount()
                  | fiat_precision_symbol: { id: fiat.getId(), currencies: [fiat] }
                  }}
                </strong>
              </div>
              <div class="text-small-black">
                {{ "inkl" | translate }}
                <strong>
                  {{
                  offer.getFee() | fiat_precision_symbol: { id: fiat.getId(), currencies: [fiat] }
                  }}
                </strong>
                <br />
                {{ "fee_transaction" | translate }}
              </div>
            </ng-container>
          </summary-grid>
        </div>
        @if (hasVipDiscount()) {
          <div class="best-fee-collection__deposit_reduction">
            <div class="best-fee-collection__best_background">
              <span class="best-fee-collection__best_icon bpi__asset-best"></span>
            </div>
            <div class="best-fee-collection__info_text">
              {{
              "best_fee_collection_deposit_reduction_summary"
              | translate
              : [
              currentBestRewardLevel,
              offer?.getBfcDifferenceAmount()
              | fiat_precision_symbol
              : { id: fiat.getId(), symbol: true, currencies: [fiat] }
              ]
              }}
            </div>
          </div>
        }
      </div>
    </div>
    <!--
    *
    *
    *   BOTTOM
    *
    *
    -->
    @if (!createdFwt) {
      <div>
        @if (getSummaryNotification(); as summaryNotification) {
          <div class="pt-0 summary-notification">
            <span class="summary-notification-text">{{ summaryNotification }}</span>
          </div>
        }
        <div class="bp-modal-body-upper pt-0">
          <bp-switch [model]="this" field="providerTerms">
            <div left>
              <span class="switch-heading">{{ getProviderTerms() }}</span>
              <a [href]="getDepositToolTipLink()" [target]="'_blank'">
                <span
                  class="bpi__icon-info font-size-16 color-primary shift-down ml-5"
                  [bp-tooltip]="'deposit_summary_tooltip' | translate"
                position="top"></span>
              </a>
            </div>
            <div left>
              <span class="switch-description">{{ "provider_term_info" | translate }}</span>
            </div>
          </bp-switch>
        </div>
        <div style="text-align: center">
          <button
            class="btn btn-primary btn-summary btn-lg mod-send"
            [ngClass]="{ disabled: !accepted }"
            type="button"
            (click)="createDeposit()">
            {{ "summary_button_confirm" | translate }}
          </button>
        </div>
      </div>
    }
    @if (twoFAFiller) {
      <div class="bp-modal-body-2fa-empty"></div>
    }
  </div>
}
